<template v-if="menu.length || menu_showcase.length">
    <div :class="menu_type === 'expanded' ? 'megamenu-expand' : 'megamenu'" id="menu">
        <b-container>
            <b-navbar>
                <b-navbar-nav class="navbar" ref="navbar">
                    <b-nav-item-dropdown no-caret class="all-categories position-relative" v-if="noShowcaseItems.length" v-on:mouseenter.native="openMegaMenuItem('categories', $event)" v-on:mouseleave.native="closeMegaMenuItem">
                        <template #button-content>
                            <svg class="icon-categories" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20.007" height="14" viewBox="0 0 20.007 14">
                                <defs>
                                    <clipPath>
                                        <path d="M19.1,14H17.445a.952.952,0,0,1,0-1.9H19.1a.952.952,0,0,1,0,1.9Zm-4.961,0H.909a.952.952,0,0,1,0-1.9H14.137a.952.952,0,0,1,0,1.9ZM19.1,7.951H5.87a.951.951,0,0,1,0-1.9H19.1a.951.951,0,0,1,0,1.9Zm-16.535,0H.909a.951.951,0,0,1,0-1.9H2.563a.951.951,0,0,1,0,1.9ZM19.1,1.9H17.445a.932.932,0,0,1-.91-.95.932.932,0,0,1,.91-.95H19.1a.932.932,0,0,1,.909.95A.932.932,0,0,1,19.1,1.9Zm-4.961,0H.909A.932.932,0,0,1,0,.95.932.932,0,0,1,.909,0H14.137a.932.932,0,0,1,.91.95A.932.932,0,0,1,14.137,1.9Z" transform="translate(0 0)"/>
                                    </clipPath>
                                </defs>
                                <g>
                                    <path d="M19.1,14H17.445a.952.952,0,0,1,0-1.9H19.1a.952.952,0,0,1,0,1.9Zm-4.961,0H.909a.952.952,0,0,1,0-1.9H14.137a.952.952,0,0,1,0,1.9ZM19.1,7.951H5.87a.951.951,0,0,1,0-1.9H19.1a.951.951,0,0,1,0,1.9Zm-16.535,0H.909a.951.951,0,0,1,0-1.9H2.563a.951.951,0,0,1,0,1.9ZM19.1,1.9H17.445a.932.932,0,0,1-.91-.95.932.932,0,0,1,.91-.95H19.1a.932.932,0,0,1,.909.95A.932.932,0,0,1,19.1,1.9Zm-4.961,0H.909A.932.932,0,0,1,0,.95.932.932,0,0,1,.909,0H14.137a.932.932,0,0,1,.91.95A.932.932,0,0,1,14.137,1.9Z" transform="translate(0 0)"/>
                                </g>
                            </svg>
                            <span class="ml-1">CATEGORIAS</span>
                        </template>
                        <component :is="menu_type === 'expanded' ? 'MegaMenuExpand' :  'MegaMenuSide'" :items="noShowcaseItems" v-show="menu_show === 'categories'" />
                    </b-nav-item-dropdown>
                    <template v-if="typeof $store.state.menu_site_start === 'object'">
                        <b-nav-item v-for="item in $store.state.menu_site_start" :key="item.id" v-bind="isExternalLink(item.href) ? { href: item.href } : { to: item.href }" :target="item.target">
                            {{ item.name }}
                        </b-nav-item>
                    </template>
                    <template v-for="item in showcaseItems">
                        <li class="nav-item b-nav-dropdown dropdown" v-if="item.subitems.length && menu_type !== 'expanded'" @mouseenter="openMegaMenuItem('category-' + item.code, $event)" @mouseleave="closeMegaMenuItem('category-' + item.code)">
                            <nuxt-link :to="item.route" class="nav-link dropdown-toggle dropdown-toggle-no-caret"><span>{{ item.name }}</span></nuxt-link>
                            <ul class="dropdown-menu" v-show="menu_show === 'category-' + item.code" :style="{ top: megamenu_top + 'px' }">
                                <MegaMenuViewCategory :item="item" tag="li"/>
                            </ul>
                        </li>
                        <b-nav-item v-else :class="{'expand': menu_type === 'expanded' }" :to="'/categoria/' + item.alias">
                            {{ item.name }}
                        </b-nav-item>
                    </template>
                    <template v-if="typeof $store.state.menu_site === 'object' && $store.state.menu_site.length">
                        <b-nav-item v-for="item in $store.state.menu_site" :key="item.id" v-bind="isExternalLink(item.href) ? { href: item.href } : { to: item.href }" :target="item.target">
                            {{ item.name }}
                        </b-nav-item>
                    </template>
                    <template v-if="typeof menu_showcase === 'object' && menu_showcase.length">
                        <b-nav-item class="showcase-link" :to="'/lp/' + item.alias" v-for="item in menu_showcase" :key="item.id">
                            {{ item.name }}
                        </b-nav-item>
                    </template>
                </b-navbar-nav>
            </b-navbar>
        </b-container>
    </div>
</template>

<script>
    import categories from '~/mixins/categories'
    import MegaMenuView from "~/components/MegaMenu/MegaMenuView";
    import MegaMenuSide from "~/components/MegaMenu/MegaMenuSide";
    import MegaMenuViewCategory from "~/components/MegaMenu/MegaMenuViewCategory";
    import MegaMenuExpand from '~/components/MegaMenu/MegaMenuExpand.vue';
    import utils from "~/mixins/utils";

    export default {
        mixins: [
            categories,
            utils
        ],
        components: {
            MegaMenuViewCategory,
            MegaMenuSide,
            MegaMenuView,
            MegaMenuExpand
        },
        data() {
            return {
                menu: [],
                menu_showcase: [],
                menu_type: null,
                showcase: {},
                isShowcase: 'yes',
                menu_show: '',
                megamenu_top: 0
            }
        },
        methods: {
            itemsFilter(array, prop, value) {
                return array.filter(el => {
                    return el[prop] === value
                })
            },
            openMegaMenuItem(item, event) {
                const containerRect = this.$refs.navbar.getBoundingClientRect();
                const itemRect = event.currentTarget.getBoundingClientRect();
                this.megamenu_top = itemRect.bottom - containerRect.top;
                this.menu_show = item
            },
            closeMegaMenuItem() {
                this.menu_show = ''
            }
        },
        computed: {
            showcaseItems() {
                return this.itemsFilter(this.menu, 'showcase', 'yes')
            },
            noShowcaseItems() {
                return this.itemsFilter(this.menu, 'showcase', 'no')
            }
        },
        mounted() {
            if (process.client) {
                this.menu_type = this.$wdconfig.modules.menu?.menu_type || null;
            }
        },
        async fetch() {
            this.menu = JSON.parse(JSON.stringify(this.$store.state.categories))
            this.menu_showcase = this.$store.state.menu_showcase
        },
        watch: {
            '$route.path'(newval, oldval) {
                const boxes = document.getElementById('menu').getElementsByClassName('dropdown-menu');
                for (const box of boxes) {
                    box.classList.add('d-none');
                }
                setTimeout(() => {
                    for (const box of boxes) {
                        box.classList.remove('d-none');
                    }
                }, 50)
            }
        }
    }
</script>
